<template>
  <div class="loaderLayout">
    <div class="loaderSecondaryLayout">
      <div class="loaderPosition">
        <i class="fa fa-spinner fa-spin loaderStyle"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader"
};
</script>

<style scoped lang="scss">
.loaderLayout {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  left: calc(50% - 30px);
  z-index: 1070;
}
.loadingText {
  position: absolute;
  bottom: 15px;
  color: #979797;
  font-size: 9px;
  left: 14px;
  font-weight: bold;
  line-height: 1.17;
  opacity: 0.8;
}
.loaderSecondaryLayout {
  background-color: #ffffff;
  width: 60px;
  height: 64.5px;
  box-shadow: 0px 1px 4px 0px #888888;
  border: 1px 1px 1px 1px solid;
  border-radius: 7px;
}
.loaderPosition {
  position: relative;
  right: 3px;
}
.loaderStyle {
  color: #4c8ce4;
  font-size: 33px;
  position: relative;
  top: 15px;
  left: 17px;
}
@media screen and (min-width: 360px) and (max-width: 768px) {
  .loaderLayout {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-42%);
    transform: translateY(-42%);
    left: 42%;
    z-index: 10;
  }
}
</style>
